import React from 'react';
import type { SVGPropsWithClassName } from './types';
import { colors } from '@/styles';

export const Envelope = ({
  size = 14,
  title = 'Envelope',
  fill = colors.silverSand,
  className = '',
}: SVGPropsWithClassName) => {
  const height = Number(size) * 2.85;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height={height}
      viewBox="0 0 12 10"
      className={className}
    >
      {Boolean(title) && <title>{title}</title>}
      <path
        d={
          'M11.72.3A1,1,0,0,0,11,0H1A1,1,0,0,0,0,1V9a1,1,0,0,0,1,1H11a1,1,0,0,0,1-1V1A1,1,0,0,0,' +
          '11.72.3Zm-.81,8.56H1.09v-7L5.3,5.66a.93.93,0,0,0,.64.26,1.08,1.08,0,0,0,.64-.24l4.33-' +
          '3.76Zm-.83-7.71L6,4.74,2,1.15Z'
        }
        fill={fill}
      />
    </svg>
  );
};
